// React
import React from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as UserPasskeyIcon } from '@trimble-oss/modus-icons/dist/modus-outlined/svg/user-passkey.svg';
import Close from '@material-ui/icons/Close';
import { Button } from "@material-ui/core";

/**
 * PasskeyItem Component
 * Displays a single passkey with its details and action buttons
 */
const PasskeyItem = ({ passkey, onRename, onDelete, getLocaleTime }) => {
     return (
          <div className="passkey-item">
               <div className="passkey-item-content">
                    <div className="passkey-item-header">
                         <div className="passkey-item-icon">
                              <UserPasskeyIcon width={16} height={16} aria-hidden="true" />
                         </div>
                         <div className="passkey-item-title">{passkey.passkey_name}</div>
                    </div>
                    {passkey.created_time && (
                         <div className="passkey-item-meta">
                              {passkey.browser && passkey.os ? (
                                   <FormattedMessage 
                                        defaultMessage="Created {date} using {browser} on {os}"
                                        values={{
                                             date: getLocaleTime(passkey.created_time),
                                             browser: passkey.browser,
                                             os: passkey.os
                                        }}
                                   />
                              ) : (
                                   <FormattedMessage 
                                        defaultMessage="Created {date}"
                                        values={{
                                             date: getLocaleTime(passkey.created_time)
                                        }}
                                   />
                              )}
                         </div>
                    )}
                    {passkey.last_used_time && (
                         <div className="passkey-item-meta">
                              <FormattedMessage 
                                   defaultMessage="Last used {date}"
                                   values={{
                                        date: getLocaleTime(passkey.last_used_time)
                                   }}
                              />
                         </div>
                    )}
               </div>
               <div className="passkey-item-actions">
                    <Button 
                         className="passkey-action-link link custom-button buttonLink custom-button__focus"
                         onClick={(e) => onRename(e, passkey)}
                         disableRipple
                         aria-label={`Rename passkey named ${passkey.passkey_name}`}
                    >
                         <FormattedMessage defaultMessage="Rename" />
                    </Button>
                    <Button 
                         className="passkey-delete-btn link custom-button buttonLink custom-button__focus"
                         onClick={(e) => onDelete(e, passkey)}
                         disableRipple
                         aria-label={`Remove passkey named ${passkey.passkey_name}`}
                    >
                         <Close className="passkey-delete-btn-icon" aria-hidden="true" />
                    </Button>
               </div>
          </div>
     );
};

export default PasskeyItem;
